import * as React from "react";

const MenuFocus: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="currentColor">
            <g fill="none" fillRule="evenodd">
                <rect width="30" height="30" fill="#00205B" rx="2" />
                <path
                    fill="#FFF"
                    fillRule="nonzero"
                    d="M23.148 20.603a1.624 1.624 0 1 1-2.297 2.296L15.5 17.551l-5.35 5.347a1.61 1.61 0 0 1-1.15.477A1.624 1.624 0 0 1 7.851 20.6l5.352-5.352-5.352-5.35A1.624 1.624 0 1 1 10.15 7.6l5.351 5.355 5.352-5.352A1.624 1.624 0 1 1 23.15 9.9l-5.352 5.353 5.35 5.35Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(MenuFocus);
